<template>
  <div class="padding-box">
    <div class="topinfo" :class="{ active: prfTLookDecide != '' }">
      <div>
        <div>样品编号:</div>
        {{ dataInfo.proofListVo.sampleNo }}
      </div>
      <div>
        <div>产品编号:</div>
        {{ dataInfo.product.productNo }}
      </div>
      <div>
        <div>看样人:</div>
        {{ dataInfo.user.username }}
      </div>
      <template v-if="!prfTLookDecide">
        <div class="time" v-if="!dataInfo.isTimeoutOne">
          还有<span>{{ dataInfo.oneDay }}</span>天超时
        </div>
        <div class="time" v-else>
          已超时<span>{{ dataInfo.oneDay }}</span>天
        </div>
      </template>
    </div>

    <template v-if="isPublish">
      <div class="change-box">
        <div class="cell" @click="
            if (!prfTLookDecide) {
          brandPicker = true;
        }
          ">
          <div class="name"><span>*</span>品牌</div>
          <div class="choose" :class="[
            { color: brandName },
            { active: prfTLookDecide },
            { error: !brandName && isError },
          ]">
            {{ brandName ? brandName : "请选择"
            }}<i v-if="!prfTLookDecide" class="iconfont icon-a-xialakaobei"></i>
          </div>
        </div>
      </div>
    </template>

    <div class="change-box" v-if="salesmanList.length > 0">
      <div class="cell" @click="
          if (!prfTLookDecide) {
        advicePicker = true;
      }
        ">
        <div class="name"><span>*</span>看样意见人</div>
        <div class="choose" :class="[
          { color: userInfo.text },
          { active: prfTLookDecide },
          { error: !userInfo.text && isError },
        ]">
          {{ userInfo.text ? userInfo.text : "请选择"
          }}<i v-if="!prfTLookDecide" class="iconfont icon-a-xialakaobei"></i>
        </div>
      </div>
    </div>
    <template v-if="isPublish">
      <div class="change-box">
        <div class="cell" @click="
            if (!prfTLookDecide) {
          levelPicker = true;
        }
          ">
          <div class="name"><span>*</span>预计产品等级</div>
          <div class="choose" :class="[
            { color: levelName },
            { active: prfTLookDecide },
            { error: !levelName && validate.indexOf('level') != -1 },
          ]">
            {{ levelName ? levelName + "级" : "请选择"
            }}<i v-if="!prfTLookDecide" class="iconfont icon-a-xialakaobei"></i>
          </div>
        </div>
        <div class="cell">
          <div class="name"><span>*</span>目标售价(€ )</div>
          <div class="choose active">
            <van-field v-model="targetPrice" label="" type="number" :disabled="prfTLookDecide != ''"
              :error="!targetPrice && validate.indexOf('targetPrice') != -1" placeholder="请输入目标售价" />
          </div>
        </div>
      </div>
    </template>

    <div class="change-box textarea-box" :class="{
      error:
        (opinion == '<p><br></p>' || opinion == '') &&
        validate.indexOf('opinion') != -1,
    }">
      <div class="box-height" v-html="opinion" v-if="prfTLookDecide"></div>
      <template v-else>
        <Editor class="editor" style="height: 150px; overflow-y: hidden" :defaultConfig="editorConfig" v-model="opinion"
          @onCreated="onCreated" />
      </template>
    </div>
    <div class="texterror" v-if="
      (opinion == '<p><br></p>' || opinion == '') &&
      validate.indexOf('opinion') != -1
    ">
      看样意见未填写
    </div>
    <template v-if="isPublish">
      <div class="change-box active">
        <div class="pad20">
          <div class="cell" @click="
              if (!prfTLookDecide) {
            marketPicker = true;
          }
            ">
            <div class="name"><span>*</span>选择市场</div>
            <div class="choose" :class="[
              { active: prfTLookDecide },
              { color: marketName },
              { error: !marketName && validate.indexOf('market') != -1 },
            ]">
              {{ marketName ? marketName : "请选择"
              }}<i v-if="!prfTLookDecide" class="iconfont icon-a-xialakaobei"></i>
            </div>
          </div>
        </div>
        <div class="pad20" :class="{ grey: !marketName }">
          <div class="cell" style="border-top: 1px solid #dbdbdb" @click="
              if (!prfTLookDecide && marketName) {
            countryPicker = true;
          }
            ">
            <div class="name"><span>*</span>国家</div>
            <div class="choose" :class="[
              { color: countryName },
              { active: prfTLookDecide },
              { error: !countryName && validate.indexOf('country') != -1 },
            ]">
              {{ countryName ? countryName : "请选择"
              }}<i v-if="!prfTLookDecide" class="iconfont icon-a-xialakaobei"></i>
            </div>
          </div>
        </div>
      </div>
      <order-form ref="form" :colorList="colorList" :orderList="dataInfo.prfTLookMain.materialList"
        :prfTLookDecide="prfTLookDecide" :countryName="countryName"></order-form>
    </template>

    <div class="fontBut" v-if="!prfTLookDecide">
      <div class="last-btn" @click="backTo">
        <i class="iconfont icon-shangyibu"></i>
        <span>上一步</span>
      </div>
      <div class="but" :class="[{ disabled: !isPublish }]" @click="addColor">
        添加材质
      </div>
      <div class="but" @click="handleRefuse">拒绝看样下单</div>
      <!-- <div class="but" @click="backTo">上一步</div> -->
      <div class="but solid-but" @click="confirm">提交</div>
    </div>
    <div class="fontBut" v-else>
      <div class="but active" @click="backTo">查看样品图标记</div>
    </div>
    <van-popup v-model="marketPicker" round position="bottom">
      <van-picker :title="'选择市场'" show-toolbar v-model="marketValue" :columns="marketList"
        @cancel="marketPicker = false" @confirm="marketConfirm" />
    </van-popup>
    <van-popup v-model="advicePicker" round position="bottom">
      <van-picker :title="'看样意见人'" :default-index="defaultUser" show-toolbar v-model="marketValue"
        :columns="salesmanList" @cancel="advicePicker = false" @confirm="userConfirm" />
    </van-popup>
    <van-popup v-model="brandPicker" round position="bottom">
      <van-picker :title="'选择品牌'" show-toolbar v-model="brandType" :columns="brandList" @cancel="brandPicker = false"
        @confirm="brandConfirm" />
    </van-popup>
    <van-popup v-model="countryPicker" round position="bottom">
      <van-picker :title="'国家'" show-toolbar v-model="countryValue" :columns="countryList[marketValue]"
        @cancel="countryPicker = false" @confirm="countryConfirm" />
    </van-popup>
    <van-popup v-model="colorPicker" round position="bottom">
      <van-picker :title="'颜色要求'" show-toolbar v-model="colorValue" :columns="colorList" @cancel="colorPicker = false"
        @confirm="colorConfirm" value-key="dictLabel" />
    </van-popup>
    <van-popup v-model="levelPicker" round position="bottom">
      <van-picker :title="'预计产品等级'" show-toolbar v-model="levelValue" :columns="levelList" @cancel="levelPicker = false"
        @confirm="levelConfirm" />
    </van-popup>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import { sampleApi } from "../api/lookApi/api";
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import "@wangeditor/editor/dist/css/style.css";
import OrderForm from "./OrderForm.vue";
const pageApi = new sampleApi();

export default {
  name: "uiSampleOpinion",
  components: { Editor, OrderForm },
  data() {
    return {
      opinion: "",
      brandPicker: false,
      advicePicker: false,
      brandList: [
        {
          text: "SoBuy",
          value: 1,
        },
        {
          text: "Hestiamo",
          value: 2,
        },
        {
          text: "Haotian",
          value: 3,
        },
      ],
      validate: [],
      levelPicker: false,
      levelList: [
        { text: "A", value: "1" },
        { text: "B", value: "2" },
        { text: "C", value: "3" },
      ],
      levelName: "",
      levelValue: "",
      colorPicker: false,
      colorList: [],
      colorName: "",
      colorValue: "",
      marketPicker: false,
      marketList: [
        { text: "美加澳市场", value: "0" },
        { text: "欧洲市场", value: "1" },
        { text: "亚洲市场", value: "2" },
      ],
      marketName: "",
      marketValue: "",
      countryPicker: false,
      countryList: [
        [
          { text: "美国", value: "1" },
          { text: "加拿大", value: "2" },
          { text: "澳大利亚", value: "11" },
        ],
        [
          { text: "德国", value: "3" },
          { text: "法国", value: "4" },
          { text: "西班牙", value: "5" },
          { text: "意大利", value: "6" },
          { text: "英国", value: "7" },
        ],
        [
          { text: "日本", value: "8" },
          { text: "韩国", value: "9" },
          { text: "新加坡", value: "10" },
          { text: "阿联酋", value: "12" },
          { text: "沙特阿拉伯", value: "13" },
        ],
      ],
      countryName: "",
      brandName: "",
      brandType: "",
      countryValue: "",
      targetPrice: "",
      isError: false,
      orderAmount: "",
      ramark: "",
      prfTLookDecide: "",
      editorConfig: {
        placeholder: "(必填）请输入看样意见……",
        maxLength: 500,
        // autoFocus: false,

        // 所有的菜单配置，都要在 MENU_CONF 属性下
        MENU_CONF: {
          uploadImage: {
            fieldName: "your-fileName",
            base64LimitSize: 10 * 1024 * 1024, // 10M 以下插入 base64
          },
        },
      },
      editor: null,
      defaultUser: 0,
      userInfo: {},
      // isPublish: false,
    };
  },
  props: {
    dataInfo: {
      addition: {},
      orderList: [],
      proofListVo: {},
      prfTLookDecide: {},
      prfTLookLog: {},
      prfTLookMain: {},
      product: {},
      user: {},
    },

    nextpointerList: [],
    salesmanList: {
      default: () => {
        return [];
      },
    },
    cIsPublish: {
      type: Boolean,
    },
  },
  watch: {
    dataInfo: {
      handler() {
        this.init();
      },
    },
  },
  computed: {
    isPublish: {
      get({ cIsPublish }) {
        return cIsPublish;
      },
      set(value) {
        this.$emit("update:cIsPublish", value);
      },
    },
  },
  methods: {
    /* 确认品牌 */
    brandConfirm(event) {
      if (event) {
        this.brandName = event.text;
        this.brandType = event.value;
      }

      this.brandPicker = false;
    },

    async handleRefuse() {
      let checkList = [];
      if (this.marketValue == "") {
        if (this.validate.indexOf("market") == -1) {
          this.validate.push("market");
          checkList.push("market");
        }
      } else {
        if (this.validate.indexOf("market") != -1) {
          this.validate.splice(this.validate.indexOf("market"), 1);
          checkList.splice(this.validate.indexOf("market"), 1);
        }
      }
      if (this.countryValue == "") {
        if (this.validate.indexOf("country") == -1) {
          this.validate.push("country");
          checkList.push("country");
        }
      } else {
        if (this.validate.indexOf("country") != -1) {
          this.validate.splice(this.validate.indexOf("country"), 1);
          checkList.splice(this.validate.indexOf("country"), 1);
        }
      }
      if (checkList.length != 0) {
        return false;
      }
      this.$dialog
        .confirm({
          title: "提示",
          message: "是否确认拒绝看样下单？",
          confirmButtonColor: "#3F996C",
        })
        .then(async () => {
          let newFormData = {
            colorAsk: "",
            market: this.countryValue,
            opinion: "拒绝看样下单",
            orderAmount: "",
            pointList: [],
            productGrade: 1,
            proofId: this.$route.query.proofId,
            ramark: this.ramark ? this.ramark : "",
            targetPrice: "",
            userId: this.userInfo
              ? this.userInfo.value
              : this.$route.query.userId,
            turnDown: 1,
            mobileUserId: this.userInfo
              ? this.userInfo.value
              : this.$route.query.userId,
          };
          const res = await pageApi.subAdvice(newFormData);
          if (res.success) {
            // this.backTo();
            wx.miniProgram.navigateBack();
            this.$notify({
              message: res.message,
              type: "success",
              duration: 5000,
            });
          } else {
            this.$notify({
              message: res.message,
              type: "danger",
              duration: 5000,
            });
          }
        });
    },
    backTo() {
      this.$emit("backTo");
    },
    // 确认市场
    marketConfirm(event) {
      this.marketName = event.text;
      this.marketValue = event.value;
      this.marketPicker = false;
      this.countryName = "";
      this.countryValue = "";
      this.dataInfo.prfTLookMain.materialList = [];

    },
    userConfirm(event) {
      this.validate = [];
      this.isError = false;
      this.advicePicker = false;
      this.userInfo = event;
      this.isPublish = !event.isProGroup;
      this.salesmanList.forEach((user, index) => {
        if (user.value == event.value) {
          this.defaultUser = index;
        }
      });
      this.$emit("chooseUser", event.value);
    },
    // 确认国家
    countryConfirm(event) {
      if (event) {
        this.countryName = event.text;
        this.countryValue = event.value;
        this.dataInfo.prfTLookMain.materialList = [];
      }

      this.countryPicker = false;
    },
    // 确认等级
    levelConfirm(event) {
      this.levelName = event.text;
      this.levelValue = event.value;
      this.levelPicker = false;
    },
    // 获取颜色
    async getLookProofColors() {
      this.colorList = await pageApi.getLookProofColors();
    },
    // 确认颜色
    colorConfirm(event) {
      this.colorName = event.dictLabel;
      this.colorValue = event.dictValue;
      this.colorPicker = false;
    },
    // 验证
    validateForm() {
      // if (this.colorValue == "") {
      //   if (this.validate.indexOf("color") == -1) {
      //     this.validate.push("color");
      //   }
      // } else {
      //   if (this.validate.indexOf("color") != -1) {
      //     this.validate.splice(this.validate.indexOf("color"), 1);
      //   }
      // }
      // if (this.orderAmount == "") {
      //   if (this.validate.indexOf("orderAmount") == -1) {
      //     this.validate.push("orderAmount");
      //   }
      // } else {
      //   if (this.validate.indexOf("orderAmount") != -1) {
      //     this.validate.splice(this.validate.indexOf("orderAmount"), 1);
      //   }
      // }
      if (this.isPublish) {
        if (this.brandType == "") {
          if (this.validate.indexOf("brand") == -1) {
            this.validate.push("brand");
          }
        } else {
          if (this.validate.indexOf("brand") != -1) {
            this.validate.splice(this.validate.indexOf("brand"), 1);
          }
        }

        if (this.levelValue == "") {
          if (this.validate.indexOf("level") == -1) {
            this.validate.push("level");
          }
        } else {
          if (this.validate.indexOf("level") != -1) {
            this.validate.splice(this.validate.indexOf("level"), 1);
          }
        }

        if (this.marketValue == "") {
          if (this.validate.indexOf("market") == -1) {
            this.validate.push("market");
          }
        } else {
          if (this.validate.indexOf("market") != -1) {
            this.validate.splice(this.validate.indexOf("market"), 1);
          }
        }
        if (!this.targetPrice) {
          if (this.validate.indexOf("targetPrice") == -1) {
            this.validate.push("targetPrice");
          }
        } else {
          if (this.validate.indexOf("targetPrice") != -1) {
            this.validate.splice(this.validate.indexOf("targetPrice"), 1);
          }
        }

        if (this.countryValue == "") {
          if (this.validate.indexOf("country") == -1) {
            this.validate.push("country");
          }
        } else {
          if (this.validate.indexOf("country") != -1) {
            this.validate.splice(this.validate.indexOf("country"), 1);
          }
        }
      }

      if (this.opinion == "<p><br></p>" || this.opinion == "") {
        if (this.validate.indexOf("opinion") == -1) {
          this.validate.push("opinion");
        }
      } else {
        if (this.validate.indexOf("opinion") != -1) {
          this.validate.splice(this.validate.indexOf("opinion"), 1);
        }
      }

      if (this.isPublish) {
        let isError = this.$refs.form.checkForm() || !this.brandType;
        this.isError = isError;
      }


      if (this.validate.length > 0 || this.isError) {
        return false;
      } else {
        return true;
      }
    },
    // 提交
    confirm() {
      if (this.validateForm()) {
        let pointer = JSON.parse(JSON.stringify(this.nextpointerList));
        pointer = pointer.filter((item) => {
          return item.userId == this.$route.query.userId;
        });
        this.$dialog
          .confirm({
            title: "提示",
            message: "是否确认提交？",
            confirmButtonColor: "#3F996C",
          })
          .then(async (action) => {
            let orderList = [];
            if (this.isPublish) {
              orderList = JSON.parse(JSON.stringify(this.$refs.form.formList));
              orderList.forEach((item) => {
                item.market = this.countryValue;
                item.marketType = this.marketValue * 1 + 1;
                item.countryList.forEach((country) => {
                  country.market = item.market;
                  country.marketType = item.marketType;
                })

              });
            }
            let info = {
              colorAsk: this.colorValue,
              market: this.countryValue,
              opinion: this.opinion,
              orderAmount: this.orderAmount,
              pointList: pointer,
              productGrade: this.levelValue,
              proofId: this.$route.query.proofId,
              targetPrice: this.targetPrice,
              userId: this.$route.query.userId,
              ramark: this.ramark ? this.ramark : "",
              mobileUserId: this.userInfo
                ? this.userInfo.value
                : this.$route.query.userId,
              materialList: orderList,
              turnDown: 2,
              brandType: this.brandType,
            };
            let res = await pageApi.addLookIdea(info);
            if (res.success) {
              // this.backTo();
              wx.miniProgram.navigateBack();
              this.$notify({
                message: res.message,
                type: "success",
                duration: 5000,
              });
            } else {
              this.$notify({
                message: res.message,
                type: "danger",
                duration: 5000,
              });
            }
          });
      }
    },
    addColor() {
      if (this.isPublish) {
        scrollTo({ top: 200, behavior: "smooth" });
        this.$refs.form.addColor();
      }
    },
    // 初始化
    init() {
      if (this.dataInfo.prfTLookMain) {
        this.colorList.forEach((item) => {
          if (item.dictValue == this.dataInfo.prfTLookMain.colorAsk) {
            this.colorName = item.dictLabel;
            this.colorValue = this.dataInfo.prfTLookMain.colorAsk;
          }
        });
        this.levelList.forEach((item) => {
          if (item.value == this.dataInfo.prfTLookMain.productGrade) {
            this.levelName = item.text;
            this.levelValue = this.dataInfo.prfTLookMain.productGrade;
          }
        });
        this.countryList.forEach((item, index) => {
          item.forEach((childitem) => {
            if (childitem.value == this.dataInfo.prfTLookMain.market) {
              this.marketName = this.marketList[index].text;
              this.marketValue = this.marketList[index].value;
              this.countryName = childitem.text;
              this.countryValue = this.dataInfo.prfTLookMain.market;
            }
          });
        });
        this.brandName = this.dataInfo.prfTLookMain.brandTypeName;
        this.brandType = this.dataInfo.prfTLookMain.brandType;
        this.targetPrice = this.dataInfo.prfTLookMain.targetPrice;
        this.orderAmount = this.dataInfo.prfTLookMain.orderAmount;
        this.opinion = this.dataInfo.prfTLookMain.opinion;
        this.ramark = this.dataInfo.prfTLookMain.ramark;
        this.prfTLookDecide =
          this.dataInfo.prfTLookDecide.temporary == 2 ? true : "";
      }
    },

    onCreated(editor) {
      // const that = this
      this.editor = Object.seal(editor); // 【注意】一定要用 Object.seal() 否则会报错
      this.$nextTick(() => {
        const editor = this.editor;
        editor.setHtml(this.opinion);
      });
    },
  },
  async mounted() {
    window.sessionStorage.setItem("title", "样品图");
    await this.getLookProofColors();
  },
};
</script>

<style lang="scss" scoped>
::v-deep .van-field__control:disabled {
  color: #303133;
  -webkit-text-fill-color: #303133;
}

::v-deep .w-e-text-placeholder {
  top: 0 !important;
  font-style: normal;
}

::v-deep .w-e-text-container [data-slate-editor] p {
  margin: 0;
  text-align: left;
  font-size: 32px;
}

.texterror {
  color: #f56c6c;
  font-size: 24px;
  margin-top: 16px;
  text-align: left;
}

.van-cell {
  padding: 0;
}

.padding-box {
  width: 100%;
  position: relative;
  overflow: hidden;
  background: #f1f1f1;
  box-sizing: border-box;
  padding: 30px 30px 200px;
  min-height: calc(100vh - 88px);

  .topinfo {
    width: 100%;
    background: #fff;
    box-sizing: border-box;
    padding: 66px 20px 10px;
    text-align: left;
    border-radius: 22px;
    position: relative;
    word-break: break-all;
    word-wrap: break-word;

    >div {
      color: #303133;
      font-size: 32px;
      line-height: 52px;
      display: flex;

      >div {
        width: 150px;
        flex-shrink: 0;
        text-align: right;
        margin-right: 10px;
        word-break: break-all;
        word-wrap: break-word;
      }

      &.active {
        text-align: right;
        line-height: 52px;
      }
    }

    &.active {
      padding-top: 20px;
    }

    .time {
      position: absolute;
      right: 20px;
      top: 20px;
      color: #909399;
      font-size: 26px;
      text-align: right;

      span {
        color: #3f996c;
      }
    }
  }

  .change-box {
    width: 100%;
    background: #fff;
    box-sizing: border-box;
    padding: 0 20px;
    border-radius: 22px;
    position: relative;
    margin-top: 30px;
    overflow: hidden;

    &.active {
      padding: 0;
    }

    &.textarea-box {
      padding: 20px 20px;
      text-align: left;
      font-size: 32px;

      .box-height {
        min-height: 200px;
      }

      &.error {
        border: 1px solid #f56c6c;
      }
    }
  }
}

.fontBut {
  .but {
    flex-shrink: 0;
    width: 160px;
    font-size: 23px;

    &.disabled {
      border-color: #dbdbdb;
      color: #dbdbdb;
    }
  }

  .last-btn {
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 10px;

    i {
      font-size: 32px;
    }

    span {
      font-size: 21px;
      color: #606266;
    }
  }
}
</style>
